/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MaritalStatus = {
    MARRIED: 'MARRIED',
    SINGLE: 'SINGLE',
    DIVORCED: 'DIVORCED',
    WIDOWED: 'WIDOWED'
} as const;
export type MaritalStatus = typeof MaritalStatus[keyof typeof MaritalStatus];

